module.exports = __webpack_public_path__ + "static/media/PM95.93d7c6d9.png";